import { render, staticRenderFns } from "./MasterDataBase.vue?vue&type=template&id=628f8abb&scoped=true"
import script from "./MasterDataBase.vue?vue&type=script&lang=js"
export * from "./MasterDataBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f8abb",
  null
  
)

export default component.exports